import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/app/store/hooks';
import { ROUTES } from '@/shared/config/routes';

/** `/` — sends a signed-in user to `/stores`, everyone else to `/login`. */
export function RootRedirect() {
  const status = useAppSelector((state) => state.auth.status);

  if (status === 'authenticated') {
    return <Navigate to={ROUTES.stores} replace />;
  }

  return <Navigate to={ROUTES.login} replace />;
}
